<template>
	<div>
		<div class="form-inline">
			<template v-for="tag in tags">
				<span id="tag">
					<v-chip outlined>{{ tag }}
						<v-btn text x-small v-if="deletable" @click="removeTag(tag)">
							<v-icon color="error" small>$delete</v-icon>
						</v-btn>
					</v-chip>
				</span>
			</template>
		</div>
		<div>
			<template v-if="updatable">
				<v-text-field id="tags" type="text" v-model="newtags" value=" " hint="多个标签之间用空格隔开" persistent-hint>
					<template v-slot:append-outer>
						<v-btn @click="updateTag" small>添加标签</v-btn>
					</template>
				</v-text-field>
			</template>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		initTags: { type: Array | String },
		deletable: { type: Boolean, default: false },
		updatable: { type: Boolean, default: false }
	},
	data() {
		return {
			tags: [],
			newtags: ''
		}
	},
	mounted() {
		this.tags = (!this.initTags || this.initTags === '') ? [] : this.initTags
	},
	methods: {
		removeTag(tag) {
			this.$confirm('确定要删除标签[' + tag + ']？').then(r => {
				if (!r) return
				let idx = this.tags.findIndex(e => e == tag)
				if (idx >= 0) {
					this.tags.splice(idx, 1)
					this.$emit('changed', this.tags)
					alert(`删除成功`)
				}
			})

		},
		updateTag() {
			let ts = this.newtags.split(' ').filter(e => e.trim() != '')
			let self = this
			ts.forEach(e => {
				let i = self.tags.findIndex(el => el == e)
				if (i >= 0) { }
				else {
					self.tags.push(e)
				}
			})
			this.newtags = ''
			// alert("添加标签成功")
			this.$emit('changed', this.tags)
		},
	}
}
</script>
